import type { GridRenderCellParams } from '@mui/x-data-grid-premium';

export function isElementOverflown(element: HTMLElement): boolean {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

export function getTooltipContent(params: Pick<GridRenderCellParams, 'value' | 'formattedValue'>) {
    const { value, formattedValue } = params;
    if (typeof value === 'string' || typeof value === 'number') {
        return formattedValue ?? value;
    }
    return formattedValue;
}
